import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import {
  postTeamChartUnpublishUsingTeamidAndChartid,
  getDivisionTypeThemesWithDivisionidAndCharttype,
  getTeamTypeThemesWithTeamidAndCharttype
} from './../../api/cloudApiGenerated';
import { setAction as setLayoutAction } from '../../pages/LayoutEditorPage/actions/layoutEditor';
import { getProfileConfig } from './../../redux/selectors/profile';
import { setAction as setChartAction } from '../../pages/ChartEditorPage/actions/chartEditor';
import { getProjectConfig } from './../../redux/selectors/projectConfig';
import { setAction as setProjectConfigAction } from '../../redux/actions/projectConfig';
import { getAggregatedChartConfig, getChartConfig } from '../../pages/ChartEditorPage/selectors/chartEditor';
import { getConfig as getLayoutConfig } from '../../pages/TableEditorPage/selectors/tableEditor';
import actionTypes from '../../redux/actions/action-types';
import { cloneDeep } from 'lodash';

// Unpublish a project
export function* unpublish() {
  const { chartId } = yield select(getChartConfig);
  const { team } = yield select(getProfileConfig);
  const { storyId, type } = yield select(getLayoutConfig);

  let id = chartId;
  if (type === 'table' || type === 'layout') id = storyId;

  yield call(postTeamChartUnpublishUsingTeamidAndChartid, team.id, id);

  yield put(
    setProjectConfigAction({
      embedDetails: {},
      published: false,
      lastPublishTime: false
    })
  );
}

export function* showSignupModal() {
  let chartEditorPage = yield select(getChartConfig);
  const { showChartWizard, dataId, referenced, live } = chartEditorPage;
  const projectConfig = yield select(getProjectConfig);
  let { projectName } = projectConfig;

  let body = {};
  let project = {};
  project = getAggregatedChartConfig(projectConfig, chartEditorPage);

  let titleValue = projectName;

  if (!projectName) {
    if (project?.title?.text) {
      titleValue = project?.title?.text;
    } else titleValue = 'Untitled chart';
  }

  body = {
    data: JSON.stringify(project),
    dataId,
    referenced,
    live,
    name: titleValue // showChartWizard ? titleValue : window.Everviz.evervizEditor.getChartTitle()
  };

  // Anon project, pop up modal
  yield put(
    setChartAction({
      editorChartConfig: body,
      signupModalOpen: true
    })
  );
}

export function* getThemes(params) {
  let { team, division, type } = params.data;

  if (!team) {
    yield put(
      setLayoutAction({
        themes: []
      })
    );
    return;
  }

  const chartConfig = yield select(getChartConfig);
  const chartConstr = chartConfig.constr || 'Chart';
  const themesMap = {
    Chart: 1,
    StockChart: 2,
    Map: 3
  };

  let themeType = themesMap[chartConstr];
  if (type === 'table') themeType = 5;
  else if (type === 'layout') themeType = 4;

  const getThemesAjax = () => {
    if (division && division.id !== null) {
      return getDivisionTypeThemesWithDivisionidAndCharttype(division.id, themeType);
    } else if (team && team.id) return getTeamTypeThemesWithTeamidAndCharttype(team.id, themeType);
  };

  try {
    const data = yield call(getThemesAjax);
    // TODO: set this on generic project config instead
    yield put(
      setLayoutAction({
        themes: data.data
      })
    );
  } catch (e) {
    throw new Error(e);
  }
}

export function* updateCSSModules(params) {
  let { newModule } = params.data;
  const { cssModules: oldCSSModules } = yield select((state) => state.projectConfig);
  const cssModules = cloneDeep(oldCSSModules);

  if (!cssModules.includes(newModule)) {
    cssModules.push(newModule);
  }

  yield put(
    setProjectConfigAction({
      cssModules
    })
  );
}

export function* watchUnpublish() {
  yield takeEvery(actionTypes.projectConfig.unpublish, unpublish);
}
export function* watchShowSignupModal() {
  yield takeEvery(actionTypes.projectConfig.showSignupModal, showSignupModal);
}
export function* watchGetThemes() {
  yield takeEvery(actionTypes.projectConfig.getThemes, getThemes);
}
export function* watchUpdateCSSModules() {
  yield takeEvery(actionTypes.projectConfig.updateCSSModules, updateCSSModules);
}

export default function* rootSaga() {
  yield all([watchUnpublish(), watchShowSignupModal(), watchGetThemes(), watchUpdateCSSModules()]);
}
